import {InjectionToken} from '@angular/core'
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core'
import {LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS} from '@angular/material-luxon-adapter'

export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')
export const WINDOW = new InjectionToken<Window>('window')
export const PROPERTY = new InjectionToken<string>('PROPERTY')


export const provideDates = () => ([
  {provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS},
  {
    provide: DateAdapter,
    useClass: LuxonDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS]
  }
])